import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import Cookie from 'react-cookies';
import { getPositions, updateUserDetails } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DeleteForever } from '@mui/icons-material';
import statesData from './states.json'
const EditUser = () => {
	const navigate = useNavigate();
	const user = Cookie.load('editData');
    const [data, setData] = useState(Cookie.load('editData'));
	// const [image, setImage] = useState(data.img);
	const [states, setStates] = useState(statesData);
		const [lgas, setLgas] = useState();
		const [positions, setPositions] = useState(null);
    const handleChange = (e) => {
        let v = e.target.value;
        let k = e.target.name;
        setData({...data, [k]:v});

    }
	const fetchPositions = async () => {
			const res = await getPositions();
			if(res.success){
				setPositions(res.data);
			}
		}
	const handleSubmit = async (e) => {
		e.preventDefault()
	  //   window.start_load();
		let formId = document.getElementById('updateUser');
		const formData = new FormData(formId);
		// formData.append('memberId', data.memberId);
		const process = async () => {
		//   if(typeof(image[0]) === 'object'){
		// 	  formData.append('file', image[0]);
		// 	  formData.append('imageStatus', 1);
		//   }else{
		// 	formData.append('imageStatus', 0);
		//   }
		  // console.log(formData);
		  const response = await updateUserDetails(formData);
		//   console.log(response);
		  if(response.success){
			  // Swal.fire('Success', response.message, 'success');///
			  Swal.fire({
				  title: 'Successful',
				  icon:"success",
				  text: response.message,
				  closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
			  })
		  }else{
			  // Swal.fire('Failed', response.message, 'error')
			  Swal.fire({
				  title: 'Failed',
				  icon:"error",
				  text: response.message,
				  // showCloseButton: true,
				  showConfirmButton: false,
				  timer: 5000
				  // closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
			  })
		  }
		}
		  process();
	  }
    // console.log()
	useEffect(() => {
		fetchPositions();
		// console.log(data);
	}, [])
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">Update Staff Account Details </b></h4> 
		<div className="card">
				<div className="card-body">
					<form action="" id="updateUser"
					onSubmit={handleSubmit}
					>
						<div className="row">
							<div className="col-md-6 border-right">
								<b className="text-muted">Personal Information</b>
								
								<div className="form-group">
									<label for="" className="control-label">Name</label>
									<input
									value={data.name}
									onChange={handleChange}
									type="text" name="name" className="form-control form-control-sm" required />
								</div>
								<div className="form-group">
									<label className="control-label">Email</label>
									<input 
									value={data.email}
									onChange={handleChange}
									type="email" className="form-control form-control-sm" name="email"  />
									<small id="#msg"></small>
								</div>
								<div className="form-group">
									<label for="" className="control-label">Phone</label>
									<input 
									value={data.phone}
									onChange={handleChange}
									type="text" name="phone" className="form-control form-control-sm"  />
								</div>
								<div className="form-group">
									<label className="control-label">Date of Birth</label>
									<input
									value={data.dob}
									onChange={handleChange}
									type="date" className="form-control form-control-sm" name="dob"/>
								</div>
								<div className="form-group">
									<label className="control-label">Highest Qualification </label>
									<Form.Select 
									onChange={handleChange}
									value={data.qualification}
									size='sm' name="qualification" id="qualification" className="form-control">
										<option value="" >Select Qualification ... </option>
										<option value="PHD" >PHD </option>
										<option value="MSC" >MSC</option>
										<option value="Degree" >BSC/BTECH/BENG/BED </option>
										<option value="HND" >HND</option>
										<option value="OND" >OND </option>
										<option value="NCE" >NCE</option>
										<option value="SSCE" >SSCE </option>
										<option value="JSCE" >JSCE</option>
										<option value="PSLC" >PSLC </option>
									</Form.Select>
								</div>
								<div className="form-group">
									<label className="control-label">Course of Study </label>
									<input 
									onChange={handleChange}
									value={data.course}
									type="text" className="form-control form-control-sm" name="course" />
									
								</div>
							</div>
							<div className="col-md-6">
							<b className="text-muted">Other Details </b>
							<div className="form-group">
								<label className="control-label">Date of Employment</label>
								<input
								value={data.doe}
								onChange={handleChange}
								type="date" className="form-control form-control-sm" name="doe"/>
							</div>
							<div className="form-group">
								<label className="control-label">Origin</label>
								<div className='d-flex justify-content-between'>
									<div className='form-group'>
										<label className="control-label">State</label>
										<Form.Select name='state' 
										value={data.state}
										onChange={(e)=>{
											setLgas(JSON.parse(e.target.value).lgas)
											setData({...data, state:JSON.parse(e.target.value).state})
										}}>
											<option value={data.state}> {data.state} </option>
											{
												states.map((state, i) => 
												{
		
												return(
													<option value={JSON.stringify(state)} key={i}
													> {state.state }</option>
												)})
											}
										</Form.Select>
									</div>
									<div className='form-group'>
										<label className="control-label">LGA</label>
										<Form.Select name='lga' 
										value={data.lga}
										onChange={handleChange}>
											<option value={data.lga} > {data.lga} </option>
											{
												lgas && lgas.map((lga, i) => (
													<option value={lga} key={i}>{lga}</option>
												))
											}
										</Form.Select>
									</div>
								</div>
									
							</div>
							<div className="form-group">
									<label className="control-label">Address </label>
									<input 
									value={data.address}
									onChange={handleChange}
									type="text" className="form-control form-control-sm" name="address" />
									
								</div>
							<div className="form-group">
								<label className="control-label">Permanent Home Address </label>
								<input 
								value={data.permanent_address}
								onChange={handleChange}
								type="text" className="form-control form-control-sm" name="permanent_address" />
									
							</div>
							<div className="form-group">
								<label for="" className="control-label">Gender</label>
								<Form.Select 
								value={data.gender}
								onChange={handleChange}
								size='sm' name="gender" id="gender" className="form-control">
									<option value="" >Select Gender ... </option>
									<option value="male" >Male </option>
									<option value="female" >Female</option>
								</Form.Select>
								<small><i></i></small>
							</div>
								<div className="form-group">
									<label className="control-label">Position </label>
									<Form.Select 
									disabled={user.access_type > 1 ? false : true}
									value={data.position}
									onChange={(e) => {
										let value = JSON.parse(e.target.value);
										setData({...data, position: value.title, 
											access_type: value.access_type, 
											category: value.category})
									}}
									size='sm' name="position" id="position" className="form-control">
										<option value={data.position} >{data.position} </option>
										{
											positions && 
											positions.map((position, i) => (
												<option value={JSON.stringify(position)}  key={i}> {position.title}</option>
											))
										}
									</Form.Select>
								</div>
								<div className="form-group">
									<label className="control-label">Staff ID</label>
									<input 
									value={data.staffId}
									disabled
									onChange={handleChange}
									type="text" className="form-control form-control-sm" name="staffId"/>
									
								</div>
								{/* <div className="form-group">
									<label for="" className="control-label">Account Status</label>
									<Form.Select 
									onChange={handleChange}
									size='sm' name="status" id="type" className="form-control">
										<option value="" >Select Status ... </option>
										<option value="1" >Active </option>
										<option value="0" >Disabled</option>
									</Form.Select>
									<small><i></i></small>
								</div> */}
							</div>
						</div>
						<hr />
						<div className="col-lg-12 text-right justify-content-center d-flex">
							 <button className="btn btn-danger btn-lg" type="button" 
							 onClick={()=> {
								Cookie.remove('editData');
								navigate('/users');
							 }}
							 style={{ width: '120px' }}
							 >Close</button>
							 <button
							 
							 className="btn btn-color btn-lg ms-2"
							  style={{ width: '120px' }}
							 >Update</button> 
						</div>
					</form>
				</div>
			</div>
    </div>
  )
}

export default EditUser